import ModalVerifyTransfer from "./ModalVerifyTransfer";

export default ModalVerifyTransfer;
